// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tZgr","col":"styles_col__2BPJg"};